// Backbone View for tooltips
var $ = jQuery;
var GroupTooltipSocial = Backbone.View.extend({
    initialize: function (options) {
        var layout = model.get('layout');
        // we set current block on call, so we need options array to bind data properly
        this.options = options;
        _.bindAll(this, 'bindings');
    },
    bindings: function () {
        var layout = model.get('layout');
        var result = {};
        var field = this.options.field_name;
        var field_model = 'styles.' + layout + '.' + field;
        result['[name="group_' + field + '_color"]'] = field_model + '_color'; // social icons size
        result['[name="group_' + field + '_size"]'] = field_model + '_size'; // social icons size
        result['[name="group_' + field + '_align"]'] = field_model + '_align'; // block top margin
        result['[name="group_' + field + '_top_margin"]'] = field_model + '_top_margin'; // block top margin

        result['.btn-group-align'] = {
            observe: field_model + '_align',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                $el.find('input').val(val);
                $el.find('.' + this.options.field_name + '_align_' + val).addClass('active');
            }
        };

        return result;
    },
    render: function(){
        this.stickit();
        return this;
    },
    close: function(){
        this.unstickit();
        //delete this.$el;
        //delete this.el;
    }
});